import ReactDOM from 'react-dom/client';
import { TenantContext } from '../../context/tenant-context';
import { v2Component } from '../../index';
import { CheckoutView } from './checkout-view';
import { CustomerContextProvider } from '../../context/customer-context';

export function initCheckoutView() {
  const elements = document.getElementsByName('checkout-view');
  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');

      const root = ReactDOM.createRoot(element);
      const { tenant, contextPath, ...props } = Object.assign({}, element.dataset) as any;

      root.render(
        v2Component(
          <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
            <CustomerContextProvider>
              <CheckoutView {...props} />
            </CustomerContextProvider>
          </TenantContext.Provider>,
        ),
      );
    }
  });
}
